import { render } from "./userInfoDialog.vue?vue&type=template&id=bed37a02&scoped=true"
import script from "./userInfoDialog.vue?vue&type=script&lang=js"
export * from "./userInfoDialog.vue?vue&type=script&lang=js"

import "./userInfoDialog.vue?vue&type=style&index=0&id=bed37a02&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed37a02"]])

export default __exports__